// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-modal-layout {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90%;
  background-color: rgba(31, 27, 250, 0.103);
  max-width: 100%;
  padding: 10px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.confirmation-modal-title-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* margin-top: 5%; */
  flex: 1 1;
  margin: 10px;
}

.confirmation-buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  max-width: 400px;
  margin-bottom: 10px;
  max-height: 40px;
  flex: 1 1;
}

.confirmation-modal-button {

  display: flex;
  width: 100px;
  background-color: rgb(241,94,94);
  justify-content: center;
  color: white;
  border-radius: 3px;  
  align-items: center;
  margin: 10px;
  height: 30px;
}

.confirmation-modal-button.cancel {
  background-color: rgb(77, 77, 77);
}

.confirmation-modal-title {

}

.confirmation-modal-layout img {
 width:192px;
 height: 192px;
}

.confirmation-modal-image-container {
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Modal/modals/ConfirmationModal/ConfirmationModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,SAAO;AACT;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;AAEA;;AAEA;CACC,WAAW;CACX,aAAa;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB","sourcesContent":[".confirmation-modal-layout {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 90%;\n  background-color: rgba(31, 27, 250, 0.103);\n  max-width: 100%;\n  padding: 10px;\n  margin-left: 10px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.confirmation-modal-title-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  /* margin-top: 5%; */\n  flex: 1;\n  margin: 10px;\n}\n\n.confirmation-buttons-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  max-width: 400px;\n  margin-bottom: 10px;\n  max-height: 40px;\n  flex: 1;\n}\n\n.confirmation-modal-button {\n\n  display: flex;\n  width: 100px;\n  background-color: rgb(241,94,94);\n  justify-content: center;\n  color: white;\n  border-radius: 3px;  \n  align-items: center;\n  margin: 10px;\n  height: 30px;\n}\n\n.confirmation-modal-button.cancel {\n  background-color: rgb(77, 77, 77);\n}\n\n.confirmation-modal-title {\n\n}\n\n.confirmation-modal-layout img {\n width:192px;\n height: 192px;\n}\n\n.confirmation-modal-image-container {\n  display: flex;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
